import React from "react";
import {css, Interpolation, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {HorizontalListIcon, PropertyPlanIcon} from "@pg-design/icons-module";

export enum PropertyListType {
    TABLE = "table",
    TILES = "tiles"
}

interface IPropertyListTabSwitcher {
    currentPropertyListType: PropertyListType;
    setCurrentPropertyListType: (type: PropertyListType) => void;
    buttonCss?: Interpolation<Theme>;
    className?: string;
}

export const PropertyListTabSwitcher: React.FC<IPropertyListTabSwitcher> = (props) => {
    const buildingModelOpen = (listType: PropertyListType) => {
        props.setCurrentPropertyListType(listType);
    };

    return (
        <ul css={propertyTabList} className={props.className}>
            <TabSwitcherStyledButton
                variant="none_secondary"
                size="medium"
                iconLeft={PropertyPlanIcon}
                isActive={props.currentPropertyListType === PropertyListType.TILES}
                onClick={() => buildingModelOpen(PropertyListType.TILES)}
                css={props.buttonCss}
            >
                Rzuty
            </TabSwitcherStyledButton>
            <TabSwitcherStyledButton
                variant="none_secondary"
                size="medium"
                iconLeft={HorizontalListIcon}
                isActive={props.currentPropertyListType === PropertyListType.TABLE}
                onClick={() => buildingModelOpen(PropertyListType.TABLE)}
                css={props.buttonCss}
            >
                Lista
            </TabSwitcherStyledButton>
        </ul>
    );
};

interface ButtonProps {
    isActive?: boolean;
}

export const TabSwitcherStyledButton = styled(Button)<ButtonProps>`
    padding: 1.6rem 3.6rem;
    min-width: unset;

    ${(props) =>
        !props.isActive &&
        css`
            opacity: 0.5;
        `}

    :hover {
        color: ${({theme}) => theme.colors.secondary};
        fill: ${({theme}) => theme.colors.secondary};
    }
`;

const propertyTabList = css`
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    list-style: none;
    margin: 0;
`;
import React from "react";
import {css, Interpolation, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {HorizontalListIcon, PropertyPlanIcon} from "@pg-design/icons-module";

export enum PropertyListType {
    TABLE = "table",
    TILES = "tiles"
}

interface IPropertyListTabSwitcher {
    currentPropertyListType: PropertyListType;
    setCurrentPropertyListType: (type: PropertyListType) => void;
    buttonCss?: Interpolation<Theme>;
    className?: string;
}

export const PropertyListTabSwitcher: React.FC<IPropertyListTabSwitcher> = (props) => {
    const buildingModelOpen = (listType: PropertyListType) => {
        props.setCurrentPropertyListType(listType);
    };

    return (
        <ul css={propertyTabList} className={props.className}>
            <TabSwitcherStyledButton
                variant="none_secondary"
                size="medium"
                iconLeft={PropertyPlanIcon}
                isActive={props.currentPropertyListType === PropertyListType.TILES}
                onClick={() => buildingModelOpen(PropertyListType.TILES)}
                css={props.buttonCss}
            >
                Rzuty
            </TabSwitcherStyledButton>
            <TabSwitcherStyledButton
                variant="none_secondary"
                size="medium"
                iconLeft={HorizontalListIcon}
                isActive={props.currentPropertyListType === PropertyListType.TABLE}
                onClick={() => buildingModelOpen(PropertyListType.TABLE)}
                css={props.buttonCss}
            >
                Lista
            </TabSwitcherStyledButton>
        </ul>
    );
};

interface ButtonProps {
    isActive?: boolean;
}

export const TabSwitcherStyledButton = styled(Button)<ButtonProps>`
    padding: 1.6rem 3.6rem;
    min-width: unset;

    ${(props) =>
        !props.isActive &&
        css`
            opacity: 0.5;
        `}

    :hover {
        color: ${({theme}) => theme.colors.secondary};
        fill: ${({theme}) => theme.colors.secondary};
    }
`;

const propertyTabList = css`
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    list-style: none;
    margin: 0;
`;
